<script>
import CommonSubtitle from "../../CommonSubtitle/index.vue";
import CustomTextField from "../../CustomInput/CustomTextField.vue";
import CustomCheckbox from "../../global/CustomCheckBox/CheckBox.vue";
import { Cities, Districts } from "../../../utils/constants";
import { mapState } from "vuex";
import CustomSelect from "../../global/CustomSelect/index.vue";

export default {
  props: {
    addressInfo: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: false,
      default: false,
    },
    v$: {
      type: Object,
      required: true,
    },
  },
  name: "AddressInfo",
  components: { CustomSelect, CustomCheckbox, CustomTextField, CommonSubtitle },
  data() {
    return {
      isSameAddress: false,
      isHydratingRegisteredAddress: false,
      isHydratingCurrentAddress: false,
      cities: Cities.map((item) => ({ id: item.code, label: item.name })),
      chosenCity: null,
      chosenDistrict: null,
      currentChosenCity: null,
      currentChosenDistrict: null,
      form: {
        city: null,
        district: null,
        currentCity: null,
        currentDistrict: null,
        // currentCommission: null,
      },
      currentAddress: null,
    };
  },
  mounted() {
    if (this.user && this.user.addresses && this.user.addresses.length > 0) {
      const idAddress = this.user.addresses.find(
        (address) => address.address_type === "ID",
      );
      this.currentAddress = this.user.addresses.find(
        (address) => address.address_type === "CURRENT",
      );

      if (idAddress) {
        this.addressInfo.khoroo = idAddress.khoroo;
        this.addressInfo.apartment = idAddress.apartment;
        this.hydrateRegisteredAddress(idAddress.city, idAddress.district);
      }

      if (this.currentAddress) {
        this.addressInfo.current_khoroo = this.currentAddress.khoroo;
        this.addressInfo.current_apartment = this.currentAddress.apartment;
        this.hydrateCurrentAddress(
          this.currentAddress.city,
          this.currentAddress.district,
        );
      }
      // if (this.user.current_city) this.addressInfo.current_city = this.cities.find(item => item.label === this.user.current_city).id
      // if (this.user.current_district) this.addressInfo.current_district = this.cities.find(item => item.label === this.user.current_district)
      // if (this.user.current_street) this.addressInfo.current_khoroo = this.cities.find(item => item.label === this.user.current_street)
      // this.addressInfo.current_apartment = this.user.current_apartment
    }
    if (this.danState === true) {
      this.addressInfo.khoroo = this.tempUser.street;
      this.addressInfo.apartment = this.tempUser.apartmentnumber;
      this.hydrateRegisteredAddress(this.tempUser.city, this.tempUser.district);
    }
  },
  computed: {
    ...mapState("user", ["user", "danState", "tempUser"]),
    isChildUser() {
      return ["child", "children"].includes(this.user?.individual);
    },
    registeredDistricts() {
      if (this.form.city && this.chosenCity) {
        return Districts.filter(
          (dist) => dist.code.slice(0, 2) === this.chosenCity.id,
        ).map((item) => {
          item.id = item.code;
          item.value = item.code;
          item.label = item.name;
          return item;
        });
      }
      return [];
    },
    currentDistricts() {
      if (this.form.currentCity) {
        return Districts.filter(
          (dist) => dist.code.slice(0, 2) === this.currentChosenCity.id,
        ).map((item) => {
          item.id = item.code;
          item.value = item.code;
          item.label = item.name;
          return item;
        });
      }
      return [];
    },
    // currentCommissions() {
    //   if (this.form.currentCity && this.form.currentDistrict) {
    //     this.form.currentCommission = null;
    //     return Commissions.filter(
    //         (comm) => comm.code.slice(0, 5) === this.currentChosenDistrict.code
    //     ).map((item) => {
    //       item.id = item.code
    //       item.value = item.code
    //       item.label = item.name
    //       return item
    //     })
    //   }
    //   return []
    // },
    currentCity() {
      return this.form.currentCity;
    },
    currentDistrict() {
      return this.form.currentDistrict;
    },
    city() {
      return this.form.city;
    },
    district() {
      return this.form.district;
    },
    // currentCommission() {
    //   return this.form.currentCommission
    // },
  },
  watch: {
    city(newValue, oldValue) {
      this.chosenCity =
        this.cities.find((item) => item.id === this.form.city) ?? null;
      this.addressInfo.city = this.chosenCity?.label ?? "";
      if (!this.isHydratingRegisteredAddress && newValue !== oldValue) {
        this.chosenDistrict = null;
        this.form.district = null;
        this.addressInfo.district = "";
      }
    },
    district() {
      this.chosenDistrict =
        this.registeredDistricts.find(
          (item) => item.code === this.form.district,
        ) ?? null;
      this.addressInfo.district = this.chosenDistrict?.label ?? "";
    },
    currentCity(newValue, oldValue) {
      this.currentChosenCity =
        this.cities.find((item) => item.id === this.form.currentCity) ?? null;
      this.addressInfo.current_city = this.currentChosenCity?.label ?? "";
      if (!this.isHydratingCurrentAddress && newValue !== oldValue) {
        this.currentChosenDistrict = null;
        this.form.currentDistrict = null;
        this.addressInfo.current_district = "";
      }
    },
    currentDistrict() {
      this.currentChosenDistrict = this.currentDistricts.find(
        (item) => item.code === this.form.currentDistrict,
      );
      if (this.currentChosenDistrict) {
        this.addressInfo.current_district = this.currentChosenDistrict.label;
      }
    },
    // currentCommission() {
    //   const currentChosenCommission = this.currentCommissions.find((item) => item.code === this.form.currentCommission)
    //   if (currentChosenCommission) {
    //     this.addressInfo.current_khoroo = currentChosenCommission.label
    //   }
    // },
    isSameAddress() {
      this.addressInfo.same_address = this.isSameAddress;
    },
  },
  methods: {
    hydrateRegisteredAddress(cityLabel, districtLabel) {
      this.isHydratingRegisteredAddress = true;
      this.chosenCity =
        this.cities.find((item) => item.label === cityLabel) ?? null;
      this.form.city = this.chosenCity?.id ?? null;
      this.addressInfo.city = this.chosenCity?.label ?? cityLabel ?? "";

      this.$nextTick(() => {
        this.chosenDistrict =
          this.registeredDistricts.find(
            (item) => item.label === districtLabel,
          ) ?? null;
        this.form.district = this.chosenDistrict?.id ?? null;
        this.addressInfo.district =
          this.chosenDistrict?.label ?? districtLabel ?? "";
        this.isHydratingRegisteredAddress = false;
      });
    },
    hydrateCurrentAddress(cityLabel, districtLabel) {
      this.isHydratingCurrentAddress = true;
      this.currentChosenCity =
        this.cities.find((item) => item.label === cityLabel) ?? null;
      this.form.currentCity = this.currentChosenCity?.id ?? null;
      this.addressInfo.current_city =
        this.currentChosenCity?.label ?? cityLabel ?? "";

      this.$nextTick(() => {
        this.currentChosenDistrict =
          this.currentDistricts.find((item) => item.label === districtLabel) ??
          null;
        this.form.currentDistrict = this.currentChosenDistrict?.id ?? null;
        this.addressInfo.current_district =
          this.currentChosenDistrict?.label ?? districtLabel ?? "";
        this.isHydratingCurrentAddress = false;
      });
    },
    isBlank(value) {
      return value === null || value === undefined || `${value}`.trim() === "";
    },
    hasRegisteredAddressError(field) {
      const validationError = !!this.v$?.[field]?.$error;
      if (!this.isChildUser) {
        return validationError;
      }

      const valueMap = {
        city: this.form.city,
        district: this.form.district,
        khoroo: this.addressInfo.khoroo,
        apartment: this.addressInfo.apartment,
      };

      return (
        validationError || (this.submitted && this.isBlank(valueMap[field]))
      );
    },
    hasCurrentAddressError(field) {
      const validationError = !!this.v$?.[field]?.$error;
      if (this.isSameAddress) {
        return false;
      }

      const valueMap = {
        current_city: this.addressInfo.current_city,
        current_district: this.addressInfo.current_district,
        current_khoroo: this.addressInfo.current_khoroo,
        current_apartment: this.addressInfo.current_apartment,
      };

      return (
        validationError || (this.submitted && this.isBlank(valueMap[field]))
      );
    },
  },
};
</script>

<template>
  <div>
    <CommonSubtitle :name="$t('kyc.address')" />
    <div class="ml-4 mr-4">
      <h5 class="kyc-sub-title">{{ $t("kyc.card_address") }}</h5>
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomSelect
            :label="$t('kyc.city')"
            v-model="form.city"
            :options="cities"
            :disabled="!isChildUser"
            :error="hasRegisteredAddressError('city')"
            :error-message="$t('kyc.fill_this')"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomSelect
            :label="$t('kyc.district')"
            v-model="form.district"
            :options="registeredDistricts"
            :disabled="!isChildUser"
            :error="hasRegisteredAddressError('district')"
            :error-message="$t('kyc.fill_this')"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomTextField
            :label="$t('kyc.khoroo')"
            v-model="addressInfo.khoroo"
            :disabled="!isChildUser"
            :error="hasRegisteredAddressError('khoroo')"
            :error-message="$t('kyc.fill_this')"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomTextField
            :label="$t('kyc.apartment')"
            v-model="addressInfo.apartment"
            :disabled="!isChildUser"
            :error="hasRegisteredAddressError('apartment')"
            :error-message="$t('kyc.fill_this')"
          />
        </div>
      </div>
      <h5 class="kyc-sub-title mb-3">{{ $t("kyc.current_address") }}</h5>
      <CustomCheckbox
        v-model="isSameAddress"
        :label="$t('kyc.same_address')"
        class="ml-3 mb-4"
      />
      <div class="row" v-if="!isSameAddress">
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomSelect
            :label="$t('kyc.city')"
            v-model="form.currentCity"
            :options="cities"
            :error="hasCurrentAddressError('current_city')"
            :error-message="$t('kyc.fill_this')"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomSelect
            :label="$t('kyc.district')"
            v-model="form.currentDistrict"
            :options="currentDistricts"
            :error="hasCurrentAddressError('current_district')"
            :error-message="$t('kyc.fill_this')"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <!--          <CustomSelect-->
          <!--              :label="$t('kyc.khoroo')"-->
          <!--              v-model="form.currentCommission"-->
          <!--              :options="currentCommissions"-->
          <!--              :error="v$?.current_khoroo.$error"-->
          <!--          />-->
          <CustomTextField
            :label="$t('kyc.khoroo')"
            v-model="addressInfo.current_khoroo"
            :error="hasCurrentAddressError('current_khoroo')"
            :error-message="$t('kyc.fill_this')"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomTextField
            :label="$t('kyc.apartment')"
            v-model="addressInfo.current_apartment"
            :error="hasCurrentAddressError('current_apartment')"
            :error-message="$t('kyc.fill_this')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.kyc-sub-title {
  font-size: 14px;
  font-weight: 500;
  color: var(primary-color-new);
}
</style>
